/**
 * Create named action types
 * @param actionTypes
 * @param duckName
 */
export const createActionTypes = (actionTypes = {}, duckName = "DUCK") => {
  return Object.keys(actionTypes).reduce(
    (res, key) => ({
      ...res,
      [key]: `${duckName.toUpperCase()}_DUCK/${actionTypes[key].toUpperCase()}`
    }),
    {}
  );
};



// WEBPACK FOOTER //
// ./src/lib/utils/createActionTypes.ts